import React, { useMemo } from 'react';
import FindADealer from '../../../3_Organisms/FindADealer/FindADealer';
import { languageController } from '../../../../controllers/language/languageController';
import { VehicleData } from '../BookServiceAppointment';

interface FindDealerStepProps {
  handleNextStep: (data: any) => void;
  vehicleData?: VehicleData;
  displayServiceHoursOnly?: boolean;
}

const FindDealerStep: React.FC<FindDealerStepProps> = ({
  handleNextStep,
  vehicleData,
  displayServiceHoursOnly
}) => {

  const MemoFindADealer = useMemo(() => {
    return (
      <FindADealer
        isStepRenderType={true}
        isEVonly={undefined}
        displayServiceHoursOnly={displayServiceHoursOnly}
        formExtraParams={{} as any}
      />
    );
  }, [displayServiceHoursOnly]);

  return (
    <div className="mz-find-dealer-step-basa">
      <h5 className="mz-find-dealer-step-basa__title">{languageController.getCopy('bookServiceAppointment', 'step3Title')}</h5>
      {MemoFindADealer}
    </div>
  );
};

export default FindDealerStep;
